import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { isLoggedIn } from "@common/services/authStorage";

/**
 * Protected route, see: https://reacttraining.com/react-router/web/example/auth-workflow
 * <PrivateRoute path="/" component={PortalLayout} />
 * @param {component} props.component the private component
 * @param {} rest optional other attributes or properties
 */
const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/auth/home/",
            }}
          />
        )
      }
    />
  );
};

function mapStateToProps({ auth, userInfo }) {
  return {
    auth,
    userInfo,
  };
}

PrivateRoute.propTypes = {
  // react-redux v7 connect() returns a React.memo-wrapped object (not a plain
  // function), so PropTypes.func would warn. Accept both.
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  auth: PropTypes.object,
};

export default connect(mapStateToProps)(PrivateRoute);
